import React, { ReactNode } from "react";

import { withLayout } from "../../components/layout/Layout";
import { LoadingState } from "../../store/shared/withLoadableSlice.types";
import { AriaPageTitle } from "../../components/ariaPageTitle";
import {
  GeneralErrorContent,
  AccountErrorContent,
  ErrorBoundaryContent,
} from "./components";

import "./ErrorPage.scss";

export const shouldShowErrorPage = <S extends LoadingState>(
  state: S,
  serviceCode: number
): boolean => {
  const statusCode = state.error && state.error.code;

  return statusCode === serviceCode;
};

export enum ErrorPageType {
  General = "general",
  ErrorBoundary = "error_boundary",
  AccountError = "account_error",
}

const ERROR_PAGE_CONTENT: Record<ErrorPageType, ReactNode> = {
  [ErrorPageType.General]: <GeneralErrorContent />,
  [ErrorPageType.ErrorBoundary]: <ErrorBoundaryContent />,
  [ErrorPageType.AccountError]: <AccountErrorContent />,
};

interface ErrorPageProps {
  type?: ErrorPageType;
}

const ErrorPage = ({ type = ErrorPageType.General }: ErrorPageProps) => {
  return (
    <section className={"error-page"}>
      <AriaPageTitle pageKey={"page_title_error_page"} />
      <div className="error-page__icon">
        <svg
          width="95"
          height="110"
          viewBox="0 0 1792 1792"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="#AAAFB1"
            d="M1262 1229q8 25-4 48.5t-37 31.5-49-4-32-38q-25-80-92.5-129.5t-151.5-49.5-151.5 49.5-92.5 129.5q-8 26-31.5 38t-48.5 4q-26-8-38-31.5t-4-48.5q37-121 138-195t228-74 228 74 138 195zm-494-589q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm512 0q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm256 256q0-130-51-248.5t-136.5-204-204-136.5-248.5-51-248.5 51-204 136.5-136.5 204-51 248.5 51 248.5 136.5 204 204 136.5 248.5 51 248.5-51 204-136.5 136.5-204 51-248.5zm128 0q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"
          />
        </svg>
      </div>
      {ERROR_PAGE_CONTENT[type]}
    </section>
  );
};

export default withLayout({
  showHeaderUnderline: true,
  showHelpLink: true,
  showUserInfo: false,
  showNavigation: false,
})(ErrorPage);
